// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8b0947b5","455":"0dfba319","977":"e270fe9d"}[chunkId] + ".chunk.js";
};